module.exports = __webpack_public_path__ + "img/shield-icon.f5bbc143.svg";